var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideMenuCloseArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16401 0.270487C6.56684 0.648181 6.58748 1.28067 6.20991 1.68357L1.99995 6.17381L6.20991 10.664C6.58764 11.0669 6.5669 11.6994 6.16401 12.0771C5.76116 12.4548 5.12868 12.435 4.75092 12.0322L0.540961 7.54197C-0.180329 6.77263 -0.180357 5.57496 0.540961 4.80564L4.75092 0.316385L4.82416 0.245096C5.20635 -0.0879766 5.78618 -0.0835613 6.16401 0.270487Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideMenuCloseArrow);
export default __webpack_public_path__ + "static/media/side-menu-close-arrow.fbc991df3585887d6b498721a1b5f61e.svg";
export { ForwardRef as ReactComponent };